<template>
	<v-list class="sidebar-list pa-0 pt-10">

		<v-list-item
			v-for="resourceItem in resourcesItems"
			:key="resourceItem.upload_id"
			class="sidebar-list__item"
		>
			<v-list-item-content style="background-color: #ffffff;margin-top: 4px;border-radius: 10px;" class="d-flex">

				<a
					class="text-decoration-none d-flex pl-3 align-center"
					:href="resourceItem.url"
					target="_blank"
					@click="handleClick(resourceItem.file_real_name)"
				>
					<a
						:href="resourceItem.url"
						:title="resourceItem.file_real_name || resourceItem.filename"
						target="_blank"
						class="upload-note mr-4 mt-1"
						:style="{ 'background-color': fileIconColor(resourceItem) }"
					>
						<p class="upload-type">
							{{ fileIconName(resourceItem) }}
						</p>
					</a>

					<a
						:href="resourceItem.url"
						target="_blank"
					>
						<div class="black--text">
							<div 
								class="text-decoration-underline mb-2"
								style="font-weight: 700;font-size: 15px; color: var(--ceil-detail-text-color);"
							>
								{{resourceItem.file_real_name}}
							</div>
							<span class="date-created" style="text-underline: none!important">{{dateCreated(resourceItem.time)}}</span>
						</div>
					</a>
				</a>
			</v-list-item-content>
		</v-list-item>
	</v-list>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import Dwh from '@/mixins/Dwh'

export default {
	name: 'UploadList',
	mixins: [Dwh],
	data () {
		return {
			fileColors: [
				{ color: '#50bee8', ext: ['jpg', 'jpeg', 'psd'] },
				{ color: '#6678aa', ext: ['bmp'] },
				{ color: '#a066aa', ext: ['png', 'gif'] },
				{ color: '#f15642', ext: ['pdf'] },
				{ color: '#50bee8', ext: ['doc', 'docx'] },
				{ color: '#638674', ext: ['rtf'] },
				{ color: '#f15642', ext: ['ppt'] },
				{ color: '#84bd5a', ext: ['xls', 'xlsx'] },
				{ color: '#f7b84e', ext: ['mp3', 'wav', 'flac'] },
				{ color: '#f7b84e', ext: ['avi', 'mp4', 'mpeg'] },
				{ color: '#576d7e', ext: ['txt'] },
				{ color: '#e59f2b', ext: ['zip', 'rar', '7z', 'gz', 'gzip', 'bzip'] },
				{ color: '#41a8e1', ext: ['url'] },
			],
		}
	},
	props: {
		resourcesItems: {
			type: Array,
			default: () => [],
		}
	},
	computed: {
		...mapGetters('resources', ['resourcesList', 'isLoading', 'listMeta', 'breadCrumbs']),
		...mapGetters('event', ['event']),
	},
	methods: {
		...mapActions('resources', ['breadCrumbHandler']),

		folderClickHandler(resourceItem = {}) {
			const {resource_id: id, resources_name: name} = resourceItem

			this.breadCrumbHandler([{id, name}])
		},
		formateBreadCrumbs(resourceId) {
			const listIds = this.breadCrumbs.map(item => item.id)

			if (_.isEmpty(listIds)) {
				return {};
			}

			return {
				bread_crumbs: [...listIds, +resourceId].join(',')
			};
		},
		fileIconColor(file) {
			if (!file.filename) return '#8b8b8b'

			const extName = this.fileIconName(file)
			const colorDataObj = extName && this.fileColors.find((i) => i.ext.indexOf(extName) > -1)

			return colorDataObj ? colorDataObj.color : '#8b8b8b'
		},
		dateCreated(originalDate) {
			const date = new Date(originalDate * 1000)
			const options = { year: 'numeric', month: 'long', day: 'numeric' }
			return date.toLocaleDateString('en-US', options)
		},
		fileIconName(file) {
			if (file.metadata) {
				return (file.filename || '').split('.').pop().substring(0, 4)
			}

			return 'url'
		},
		handleClick(file_real_name) {
			if (this.$route.name === 'event-actions-by-id') {
				this.sendTrigger({
					category: 'Content',
					action: 'open_file_event',
					module: 'Events',
					title: file_real_name,
					content_chapter_id: this.event && this.event.chapter_id ? [this.event.chapter_id] : null
				})
			}
		}
	},
	created() {
		//
	}
}
</script>

<style lang="scss">
.date-created{
	font-weight: 500;
	font-size: 13px;
	text-decoration: none!important;
	color: #9B9B9B;
}
.popular-post-by-category {
	color: #37474f;
	padding: 18px 10px 16px 20px;
	border-radius: 11px;
	margin-bottom: 16px;
	width: 100%;
	background: #e2f2e9;
	box-shadow: none !important;

	&__title {
		padding-bottom: 25px;
		p {
			font-family: Montserrat, sans-serif;
			font-style: normal;
			font-weight: bold;
			font-size: 14px;
			line-height: 17px;
			letter-spacing: 0.35px;
			color: #202232;
		}

		a {
			font-family: Montserrat, sans-serif;
			font-style: normal;
			font-weight: 500;
			font-size: 12px;
			line-height: 15px;
			text-align: center;
			letter-spacing: 0.35px;
			color: #000 !important;
			mix-blend-mode: normal;
			opacity: 0.4;
			text-decoration: none;

			&:hover {
				opacity: 1;
				text-decoration: underline;
			}
		}
	}

	&__thing-title {
		.thing-link {
			font: 500 16px/1.5 'Montserrat';
		}
	}

	&__user-name {
		font-family: Montserrat, sans-serif;
		font-style: normal;
		font-weight: bold;
		font-size: 20px;
		line-height: 24px;
		letter-spacing: 0.15px;
		color: #37474f;
		word-break: break-all;
	}
	&__avatar {
		img {
			object-fit: cover;
		}
	}

	&__user-location {
		font-family: Montserrat, sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 16px;
		line-height: 24px;
		letter-spacing: 0.15px;
		color: #37474f;
	}

	&__link {
		font: 500 16px/1.5 'Montserrat';
		text-decoration: none;
		color: #37474f !important;

		&:hover {
			transition: color 0.2s, background-color 0.2s, border-color 0.2s !important;
			color: black !important;
			text-decoration: underline;
		}
	}
	.upload_content{
		background-color: #ffffff;margin-top: 4px;border-radius: 10px;
	}
}
</style>
